import { Button, DialogContent, Grid, IconButton, Box } from '@material-ui/core';
import { CloseIcon, StyledDialog, Typography } from '@room-match/shared-ui-components';
import React from 'react';
import { useStyles } from './SlateModal.styles';

type Props = {
  open: boolean;
  onClose: () => void;
};
const SlateModal: React.FC<Props> = ({ open, onClose }) => {
  const classes = useStyles();

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="lg" className={classes.root}>
      <DialogContent className={classes.content}>
        <Box component="div" className={classes.close}>
          <IconButton size="small" onClick={() => onClose()}>
            <CloseIcon style={{ fontSize: 16 }} />
          </IconButton>
        </Box>
        <Grid item>
          <Typography fontSize={24}>Slate</Typography>
        </Grid>
        <Grid item className={classes.mediaContainer}>
          <img src="/assets/no-image.svg" className={classes.img} />
        </Grid>
        <Button variant="contained" color="primary" fullWidth className={classes.buttonCls} onClick={() => onClose()}>
          Use Recording
        </Button>
      </DialogContent>
    </StyledDialog>
  );
};

export default SlateModal;
